




























































































































































































































































import { Vue, Component, Ref } from 'vue-property-decorator';
import IconSvg from './components/IconSvg.vue';
import TrendChart from './components/TrendChart.vue';
import BarChart from './components/BarChart.vue';
import ScrollBoard from './components/ScrollBoard.vue';
import Pseudo3DMap from './components/Pseudo3DMap.vue';
import Wordcloud from './components/Wordcloud.vue';
import DigitalFlipper from './components/digital-flipper/index.vue';
import Title from './components/Title.vue';
import * as api from '@/api';
import moment, { Moment } from 'moment';
import { message } from 'ant-design-vue';

@Component({
  components: { IconSvg, TrendChart, BarChart, ScrollBoard, Pseudo3DMap, Wordcloud, Title, DigitalFlipper },
})
export default class DataViews extends Vue {
  // data
  currentTime: string = new Date().toLocaleTimeString();
  currentDate: string = '';
  currentDayOfWeek: string = '';
  currentNav: string = 'dataViewIndex';
  timer: number | null = null;
  paramType = '';
  tableData = [];
  dateValues = this.getLast30DaysRangeArray();
  frontTotalCount = 0;
  negativeTotalCount = 0;
  frontData = [];
  negativeData = [];
  toDayData: any = [];
  rankData: any = [];
  allData: any = [];
  @Ref('dashboardRef') dashboardRef!: HTMLElement;

  getLast30DaysRangeArray(): [Moment, Moment] {
    const end = moment().endOf('day'); // 今天 23:59:59
    const start = moment()
      .subtract(30, 'days')
      .startOf('day'); // 30天前 00:00:00
    return [start, end];
  }

  // methods
  updateTime(): void {
    this.currentTime = new Date().toLocaleTimeString();
  }

  switchWeek(type: string) {
    // this.$refs.trendChartRef.setTypeAndFetch(type);
    (this.$refs.trendChartRef as InstanceType<typeof TrendChart>).setTypeAndFetch(type);
  }

  typeSwitchWeek(type: string) {
    // this.$refs.trendChartRef.setTypeAndFetch(type);
    (this.$refs.barChartRef as InstanceType<typeof TrendChart>).setTypeAndFetch(type);
  }

  updateDateInfo(): void {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    const dayOfWeek = now.toLocaleDateString('zh-CN', { weekday: 'long' });

    this.currentDate = `${year}-${month}-${day}`;
    this.currentDayOfWeek = dayOfWeek;
  }

  vViewFullDirective() {
    const el = this.dashboardRef;
    console.log('%c [ el ]-325', 'font-size:13px; background:pink; color:#bf2c9f;', el);
    if (!el) return;
    const sWidth = document.body.clientWidth;
    const sW = sWidth / 1920;
    el.style.transform = `scale(${sW})`;
    el.style.transformOrigin = `0px 0px`;
  }

  navClick(item: { key: string }): void {
    this.currentNav = item.key;
    this.$router.push({ name: item.key });
  }

  async getAppYqData(isPositive: boolean) {
    const data: any = await api.Yq.getAll_GET({
      isPositive: isPositive,
      reportState: null,
      eventCategoryId: null,
      keyword: '',
      theme: '',
      publisher: '',
      source: '',
      startPublishTime: null,
      endPublishTime: null,
      startCreationTime: null,
      endCreationTime: null,
      size: 100,
      p: 1,
    });

    if (isPositive) {
      this.frontData = data.data.Items;
      this.frontTotalCount = data.data.TotalCount;
    } else {
      this.negativeData = data.data.Items;
      this.negativeTotalCount = data.data.TotalCount;
    }
  }

  async getYqData() {
    try {
      const data: any = await api.Yq.GetYqData_GET({
        tag: '政策与活动类,形象与价值观类,权益与服务类,网络与文化类,合作与争议类,其他',
      });

      if (data.data.tagsCount) {
        const tempData = Object.entries(data.data.tagsCount).map(([name, value]) => ({
          name,
          value: value as number, // 类型断言（确保value为number，因Object.entries返回值为unknown）
        }));

        // 计算总数
        const totalCount = tempData.reduce((sum: number, item: any) => sum + (item.value || 0), 0);

        // 计算每个分类的百分比并添加到数据中
        this.rankData = tempData
          .map((item: any) => {
            const percentage = totalCount > 0 ? (((item.value || 0) / totalCount) * 100).toFixed(1) : '0.0';
            return {
              ...item,
              percentage: parseFloat(percentage),
              percentageText: `${percentage}%`,
            };
          })
          .sort((a: any, b: any) => (b.value || 0) - (a.value || 0));
      }

      this.allData = data.data;
    } catch (error) {
      message.error('获取舆情数据失败');
    }
  }

  async getToDayData() {
    const data: any = await api.Yq.getToday_GET({
      eventCategoryId: '',
      keyword: '',
      theme: '',
      publisher: '',
      source: '',
      city: '',
    });
    this.toDayData = data.data;

    // const tempArr = [
    //   {
    //     EventCategory: {
    //       Id: 'e498402f-31eb-478c-b63c-242712ef4b9e',
    //       AuditData: {
    //         CreatedBy: 'hcl',
    //         CreatedOn: '2015-10-13T09:25:20.68',
    //         ModifiedBy: 'hcl',
    //         ModifiedOn: null,
    //       },
    //       Sort: 8,
    //       Name: '其他',
    //       Enable: true,
    //       Remark: 'qt',
    //     },
    //     Id: 'ecf2af91-d0cf-4d8c-8bd5-6dba18293bbe',
    //     AuditData: {
    //       CreatedBy: 'hm',
    //       CreatedOn: '2025-10-09T15:30:09.09',
    //       ModifiedBy: 'hm',
    //       ModifiedOn: null,
    //     },
    //     Sort: 0,
    //     Type: 0,
    //     EventCategoryId: 'e498402f-31eb-478c-b63c-242712ef4b9e',
    //     TrafficHazards: null,
    //     EventCategoryName: '其他',
    //     Source: '小红书',
    //     UnitType: '其他',
    //     UnitTypeSort: 0,
    //     PoDutyUnit: '0147',
    //     DisplayPoDutyUnit: null,
    //     IsCooperative: true,
    //     City: '南宁',
    //     County: null,
    //     DisplayCounty: null,
    //     Theme:
    //       '广西医科大医托骗局——南宁 xinghe 中医医院\r\n因为爆痘挂广西医科大内分泌科，遭遇医托骗局差点被骗到另外一个南宁 xinghe 中医医院。最终我坚持挂内分泌科号，避免了被骗。提醒大家警惕医托，避免被诱导！\r\n#医托骗局 #广西医科大第一附属医院',
    //     ContentSummary:
    //       '10月9日，小红书网友称其因爆痘遂到广西医科大学第一附属医院挂内分泌科的号，在候诊大厅遇到医托团伙，医托团伙称其找错了门诊，应到6号楼的特殊门诊看中医，并称有1名北京来的专家徐秀元教授在坐诊，其到6号楼3楼后，另一名医托称徐秀元教授已退休，现在南宁星和中医医院坐诊，后其发现此为医托骗局，现将此事曝光。',
    //     WebSiteLink:
    //       'https://www.xiaohongshu.com/explore/68e73f93000000000302d66b?xsec_token=ABh1a2hyO2lg0seY4hKPtlpJrYhzuFyI1bnqyYeUiUYXI=&xsec_source=pc_user',
    //     PublishTime: '2025-10-09T12:52:00',
    //     Publisher: '小红薯67BF64AE（小红书号：26705571049）',
    //     ReportState: false,
    //     UseState: false,
    //     Tags: '医托骗人',
    //     IsImportant: false,
    //     IsPositiveReport: false,
    //     IsPrintReport: false,
    //     Zm: null,
    //     DieType: null,
    //     AccidentType: null,
    //     DieNumber: 0,
    //     InjuredNumber: 0,
    //     InvolveNumber: 0,
    //     IsInSchool: null,
    //     StrPublishTime: '2025/10/09 12:52',
    //     CreationTime: '2025-10-09T00:00:00',
    //     MiddleSchoolName: null,
    //     InsertDbTime: '2025-10-09T15:30:09.087',
    //     SourceTag: '人工',
    //     IsNoticed: true,
    //     NoticeTime: '2025-10-09T15:30:09.907',
    //     SendNoticeUser: 'hm',
    //     NoticeUsername: '7e3a00ad-fbbf-486f-ae83-271a3c66d6f8',
    //     NoticeDeptName: '广西医科大学第一附属医院',
    //     DealState: null,
    //     DealWithResult: null,
    //     DealWithAttachmentKey: null,
    //   },
    //   {
    //     EventCategory: {
    //       Id: 'e498402f-31eb-478c-b63c-242712ef4b9e',
    //       AuditData: {
    //         CreatedBy: 'hcl',
    //         CreatedOn: '2015-10-13T09:25:20.68',
    //         ModifiedBy: 'hcl',
    //         ModifiedOn: null,
    //       },
    //       Sort: 8,
    //       Name: '其他',
    //       Enable: true,
    //       Remark: 'qt',
    //     },
    //     Id: 'eeecbc86-4bdb-4bbc-b75e-c0899e3b7142',
    //     AuditData: {
    //       CreatedBy: 'stu8',
    //       CreatedOn: '2025-10-05T11:32:21.367',
    //       ModifiedBy: 'stu8',
    //       ModifiedOn: null,
    //     },
    //     Sort: 0,
    //     Type: 0,
    //     EventCategoryId: 'e498402f-31eb-478c-b63c-242712ef4b9e',
    //     TrafficHazards: null,
    //     EventCategoryName: '其他',
    //     Source: '今日头条',
    //     UnitType: '其他',
    //     UnitTypeSort: 0,
    //     PoDutyUnit: '0147',
    //     DisplayPoDutyUnit: null,
    //     IsCooperative: true,
    //     City: '南宁',
    //     County: null,
    //     DisplayCounty: null,
    //     Theme:
    //       '从来没遇到这么址淡的医院，号称南宁最大医院 ，连探望个病人都要预约，还必须在规定时间内，好多从偏远农村来的老年人都要按规定，都被拦不让进，谁来说说这是什扯淡的规矩',
    //     ContentSummary:
    //       '10月5日，今日头条网友“龙山浪人Hz“称广西医科大学第一附属医院要求探视病人必须提前预约且严格限定时间，导致许多从偏远农村前来的老年亲属因未能符合规定而被拒之门外规定提出质疑。',
    //     WebSiteLink: 'https://www.toutiao.com/w/1845102439869440/',
    //     PublishTime: '2025-10-05T09:13:00',
    //     Publisher: '龙山浪人Hz',
    //     ReportState: false,
    //     UseState: false,
    //     Tags: '医院管理',
    //     IsImportant: false,
    //     IsPositiveReport: false,
    //     IsPrintReport: false,
    //     Zm: null,
    //     DieType: null,
    //     AccidentType: null,
    //     DieNumber: 0,
    //     InjuredNumber: 0,
    //     InvolveNumber: 0,
    //     IsInSchool: null,
    //     StrPublishTime: '2025/10/05 09:13',
    //     CreationTime: '2025-10-05T00:00:00',
    //     MiddleSchoolName: null,
    //     InsertDbTime: '2025-10-05T11:32:21.363',
    //     SourceTag: '人工',
    //     IsNoticed: true,
    //     NoticeTime: '2025-10-05T11:32:22.3',
    //     SendNoticeUser: 'stu8',
    //     NoticeUsername: '7e3a00ad-fbbf-486f-ae83-271a3c66d6f8',
    //     NoticeDeptName: '广西医科大学第一附属医院',
    //     DealState: null,
    //     DealWithResult: null,
    //     DealWithAttachmentKey: null,
    //   },
    //   {
    //     EventCategory: {
    //       Id: '7fd0d37a-2534-4a65-b55c-4e96aec9ffca',
    //       AuditData: {
    //         CreatedBy: 'hcl',
    //         CreatedOn: '2015-10-13T09:24:59.087',
    //         ModifiedBy: '邓国峰',
    //         ModifiedOn: null,
    //       },
    //       Sort: 9,
    //       Name: '网络谣言',
    //       Enable: true,
    //       Remark: 'wlly',
    //     },
    //     Id: '6dbfe5d7-bf42-469f-a7a5-b11a6d3e5a22',
    //     AuditData: {
    //       CreatedBy: 'stu9',
    //       CreatedOn: '2025-09-20T11:02:56.653',
    //       ModifiedBy: 'stu9',
    //       ModifiedOn: null,
    //     },
    //     Sort: 0,
    //     Type: 0,
    //     EventCategoryId: '7fd0d37a-2534-4a65-b55c-4e96aec9ffca',
    //     TrafficHazards: null,
    //     EventCategoryName: '网络谣言',
    //     Source: '小红书',
    //     UnitType: '高等院校',
    //     UnitTypeSort: 0,
    //     PoDutyUnit: '0147',
    //     DisplayPoDutyUnit: null,
    //     IsCooperative: true,
    //     City: '南宁',
    //     County: null,
    //     DisplayCounty: null,
    //     Theme: '医科大一附院什么时候才能发工资啊日进斗金的地方也能拖欠工资',
    //     ContentSummary:
    //       '9月20日，小红书网友“ 炫炫仔～”（小红书号：1104054684）称广西医科大学第一附属医院拖欠工资，询问工资何时发放（经核实，此为不实信息）。',
    //     WebSiteLink:
    //       'https://www.xiaohongshu.com/explore/68cdb1e6000000001300a259?xsec_token=ABBZ6nEub4Mq5_nS8flXiSJeohqOTIGIeRtgw4RSH9mrE=&xsec_source=pc_user',
    //     PublishTime: '2025-09-20T03:41:00',
    //     Publisher: '炫炫仔～ （小红书号：1104054684）',
    //     ReportState: false,
    //     UseState: false,
    //     Tags: '网友负性评价',
    //     IsImportant: false,
    //     IsPositiveReport: false,
    //     IsPrintReport: false,
    //     Zm: null,
    //     DieType: null,
    //     AccidentType: null,
    //     DieNumber: 0,
    //     InjuredNumber: 0,
    //     InvolveNumber: 0,
    //     IsInSchool: null,
    //     StrPublishTime: '2025/09/20 03:41',
    //     CreationTime: '2025-09-20T00:00:00',
    //     MiddleSchoolName: null,
    //     InsertDbTime: '2025-09-20T11:02:56.65',
    //     SourceTag: '人工',
    //     IsNoticed: true,
    //     NoticeTime: '2025-09-20T11:02:57.94',
    //     SendNoticeUser: 'stu9',
    //     NoticeUsername: '7e3a00ad-fbbf-486f-ae83-271a3c66d6f8',
    //     NoticeDeptName: '广西医科大学第一附属医院',
    //     DealState: null,
    //     DealWithResult: null,
    //     DealWithAttachmentKey: null,
    //   },
    // ];

    // tempArr.forEach((item: any) => {
    //   this.toDayData.push(item);
    // });
  }

  // lifecycle
  mounted() {
    this.timer = window.setInterval(this.updateTime, 1000);
    this.updateDateInfo();
    this.getYqData();

    this.$nextTick(() => {
      this.currentNav = this.$route.name || 'dataViewIndex';
      this.vViewFullDirective();
    });

    this.getAppYqData(true);
    this.getAppYqData(false);
    this.getToDayData();

    window.addEventListener('resize', this.vViewFullDirective);
  }

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    window.removeEventListener('resize', this.vViewFullDirective);
  }
}
